import { Camera } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const PhotoSlot = ({ id, label, ratio = "aspect-[4/5]", className = "", testId }) => {
  const { t } = useLanguage();
  return (
    <div
      data-testid={testId || `photo-slot-${id}`}
      className={`relative ${ratio} bg-card2 border border-gold/25 flex flex-col items-center justify-center text-center p-6 overflow-hidden group hover:border-gold/70 transition-colors duration-500 ${className}`}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40 pointer-events-none" />
      <Camera className="w-6 h-6 text-gold/40 mb-4 group-hover:text-gold/70 transition-colors duration-500" strokeWidth={1.25} />
      <span className="text-xs text-dim max-w-[200px] leading-relaxed">{label}</span>
      <span className="mt-1 text-[10px] text-dim/60 italic">{t.photoHint}</span>
    </div>
  );
};
